import Modal from './Modal.vue';
import ModalHeader from './ModalHeader.vue';
import ModalFooter from './ModalFooter.vue';

export default Modal;
export {ModalHeader, ModalFooter};
